<template>
	<div class="add-product" style="background-color: white; padding: 10px 15px;">
		<el-form
			:label-position="labelPosition"
			:rules="rules"
			ref="apps"
			label-width="80px"
			:model="submitForm"
		>
			<h1 style="font-size: 18px;">{{ $t("helpcenter.yjfk") }}</h1>
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item
						:label="$t('helpcenter.fklx')"
						prop="type"
						:required="true"
						style="margin-bottom: 5px;"
					>
						<el-radio
							v-model="submitForm.type"
							v-for="item in feedbackType"
							:key="item.id"
							:label="item.value"
							>{{ item.label }}</el-radio
						>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20" style="height: 90px;">
				<el-col :span="12">
					<el-form-item
						:label="$t('helpcenter.sbbh')"
						prop="equipmentNo"
						:required="true"
						style="margin-bottom: 5px;"
					>
						<el-input
							type="number"
							v-model="submitForm.equipmentNo"
							:placeholder="$t('helpcenter.srsbbh')"
							autocomplete="off"
						></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item
						:label="$t('helpcenter.orderNumber')"
						prop="orderNumber"
						:required="true"
						style="margin-bottom: 5px;"
					>
						<el-input
							type="text"
							v-model="submitForm.orderNumber"
							:placeholder="$t('helpcenter.srorderNo')"
							autocomplete="off"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20" style="height: 90px;">
				<el-col :span="12">
					<el-form-item
						:label="$t('helpcenter.wentimiaoshu')"
						prop="content"
						:required="true"
						style="margin-bottom: 5px;"
					>
						<el-input
							type="textarea"
							:rows="4"
							v-model="submitForm.content"
							:placeholder="$t('helpcenter.srwentimiaoshu')"
							autocomplete="off"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item
						:label="$t('helpcenter.fujian')"
						style="margin-bottom: 5px;"
					>
						<el-upload
							class="upload-demo"
							:action="uploadUrl"
							:headers="headers"
							:accept="'.png,.jpg,.jpeg,.txt,.rar,.doc,.xls,.zip,.mp4'"
							:before-remove="beforeRemove"
							:on-remove="(file, fileList) => handleRemove(file, fileList)"
							:on-success="
								(response, file, fileList) =>
									handleSuccess(response, file, fileList)
							"
							:on-error="
								(err, file, fileList) => handleError(err, file, fileList, 1)
							"
							:limit="5"
							:on-exceed="handleExceed"
							:file-list="fileList"
							multiple
						>
							<el-button size="small" type="primary">{{
								$t("helpcenter.tjfujian")
							}}</el-button>
							<div
								slot="tip"
								class="el-upload__tip"
								style="margin-top: 15px; font-size: 14px; display: flow-root; height: 10px;"
							>
								{{ $t("helpcenter.xzsize1") }}
							</div>
							<div
								slot="tip"
								class="el-upload__tip"
								style="margin-top: 15px; font-size: 14px; display: flow-root; height: 10px;"
							>
								{{ $t("helpcenter.xzsize2") }}
							</div>
							<div
								slot="tip"
								class="el-upload__tip"
								style="margin-top: 15px; font-size: 14px; display: flow-root; height: 10px;"
							>
								{{ $t("helpcenter.xzsize3") }}
							</div>
							<div
								slot="tip"
								class="el-upload__tip"
								style="margin-top: 15px; font-size: 14px; color: red; display: flow-root; height: 10px;"
							>
								{{ $t("helpcenter.xzsize4") }}
							</div>
						</el-upload>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="24">
					<el-form-item
						:label="$t('helpcenter.lianxifangshi')"
						prop="phone"
						:required="true"
						style="margin-bottom: 5px;"
					>
						<el-input
							type="number"
							maxlength="11"
							v-model="submitForm.phone"
							:placeholder="$t('helpcenter.srlianxifangshi')"
							autocomplete="off"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<el-button
			type="primary"
			:disabled="loadingForm"
			@click="submitFormInfo"
			style="margin: 20px 0 10px 0;"
			>{{ $t("helpcenter.submits") }}</el-button
		>
	</div>
</template>

<script>
import config from "@/http/config";
export default {
	name: "PromoteConfig",
	data() {
		return {
			loadingForm: false,
			labelPosition: "top",
			radioType: 1,
			feedbackType: [],
			fileList: [],
			uploadUrl: config.baseUrl + this.$url.Upload.feedback,
			headers: {
				token: this.$cookies.get("token"),
			},
			submitForm: {
				type: 0,
				equipmentNo: "",
				orderNumber: "",
				phone: "",
				content: "",
				files: [],
			},
		};
	},
	mounted() {
		this.getFeedbackType();
	},
	methods: {
		getFeedbackType() {
			this.$api.dict("feedback_type").then(res => {
				if (res.code === 0) {
					this.feedbackType = res.data;
				}
			});
		},
		handleExceed(files, fileList) {
			this.$message.warning(this.$t("helpcenter.xzsize3"));
		},
		beforeRemove(file, fileList) {
			return this.$confirm(`Determine to remove ${file.name}？`);
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
			// this.submitForm.files.splice();
		},
		// 文件上传成功钩子
		handleSuccess(response, file, fileList) {
			if (response.code == 0) {
				let newfile = {
					name: file.name,
					url: response.data,
				};
				this.submitForm.files.push(newfile);
			} else {
				this.$notify({
					title: this.$t("common.tip"),
					message: this.$t("helpcenter.fjsb"),
					type: "warning",
				});
				return false;
			}
		},
		// 文件上传失败钩子
		handleError(err, file, fileList, i) {
			console.log(this.$t('helpcenter.Feedbacks.939854-0'));
		},
		submitFormInfo() {
			console.log(this.submitForm.files);
			if (!this.submitForm.type) {
				this.$notify({
					title: this.$t("common.tip"),
					message: this.$t("helpcenter.xzfklx"),
					type: "warning",
				});
				return false;
			}
			if (!this.submitForm.equipmentNo) {
				this.$notify({
					title: this.$t("common.tip"),
					message: this.$t("helpcenter.srsbbh"),
					type: "warning",
				});
				return false;
			}
			if (!this.submitForm.content) {
				this.$notify({
					title: this.$t("common.tip"),
					message: this.$t("helpcenter.srwentimiaoshu"),
					type: "warning",
				});
				return false;
			}
			if (!this.submitForm.phone) {
				this.$notify({
					title: this.$t("common.tip"),
					message: this.$t("helpcenter.srlianxifangshi"),
					type: "warning",
				});
				return false;
			}
			this.loadingForm = true;
			let url = this.$url.Feedback.insert;
			let method = this.$method.post;
			this.$api
				.request(url, method, this.submitForm)
				.then(res => {
					if (res.code === 0) {
						this.$notify({
							title: this.$t("common.tip"),
							message: res.msg,
							type: "success",
						});
						let djs = setTimeout(function() {
							clearTimeout(djs);
							window.location.reload();
						}, 1500);
					} else {
						this.$notify({
							title: this.$t("common.tip"),
							message: res.msg,
							type: "error",
						});
					}
					this.loadingForm = false;
				})
				.catch(err => {
					this.$notify({
						title: this.$t("common.tip"),
						message: err.msg,
						type: "error",
					});
					this.loadingForm = false;
				});
		},
	},
};
</script>

<style lang="scss">
.editor {
	height: 300px;
}
.el-form--label-top .el-form-item__label {
	padding: 0;
}
.add-product {
	.el-upload--picture-card {
		width: 80px;
		height: 80px;
		line-height: 88px;
	}
	.el-upload-list__item {
		width: 80px !important;
		height: 80px !important;
		margin-bottom: 0 !important;
	}
	.el-form-item__content {
		line-height: 0;
	}
}
.add-product .el-upload-list__item {
	width: 300px !important;
	height: 26px !important;
}
</style>
